// extracted by mini-css-extract-plugin
export default {"root":"IconCloseChevron_root__pkNrU"};